import { apiClient } from "@/api/api-client";
import { ApiResponse } from "@/types/api-response";
import {
  DeliveryFee,
  DeliveryFeeCreateRequest,
  DeliveryFeeUpdateRequest,
} from "@/types/delivery-fee-type";
import { endpoints } from "./endpoints/endpoints";

export async function getDeliveryFee(
  id: string
): Promise<ApiResponse<DeliveryFee>> {
  try {
    const response = await apiClient.get<DeliveryFee, void>(
      endpoints.deliveryFee.get(id)
    );
    return response as ApiResponse<DeliveryFee>;
  } catch (error) {
    console.error("Error getting delivery fee:", error);
    throw error;
  }
}

export async function createDeliveryFee(
  request: DeliveryFeeCreateRequest
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.post(
      endpoints.deliveryFee.create,
      request
    );
    console.log("Delivery fee created:", response.data);
    return response.data as ApiResponse<any>;
  } catch (error) {
    console.error("Error creating delivery fee:", error);
    throw error;
  }
}

export async function updateDeliveryFee(
  id: string,
  request: DeliveryFeeUpdateRequest
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.put(
      endpoints.deliveryFee.update(id),
      request
    );
    console.log("Delivery fee updated:", response.data);
    return response.data as ApiResponse<any>;
  } catch (error) {
    console.error("Error updating delivery fee:", error);
    throw error;
  }
}

export async function deleteDeliveryFee(
  id: string
): Promise<ApiResponse<DeliveryFee>> {
  try {
    const response = await apiClient.delete<DeliveryFee>(
      endpoints.deliveryFee.delete(id)
    );
    return response;
  } catch (error) {
    console.error("Error deleting delivery fee:", error);
    throw error;
  }
}
